import React from 'react';

import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import SearchForm from '../../SearchForm/lodging';
import Sortings from '../../Sortings/ListMenu';
import FiltersBar from '../../../containers/Home/FiltersBar';
import Button from "../../Button";
import Icon from "../../Icon";
import Drawer from "../../Drawer";

import IntlMessage from '../../../LocaleEngine';

import '../index.scss';

export default function LodgingSearchBar(props) {

    const resetFilters = () => {
        props.resetFilters();
    }

    const { toggleSearch, searchHandler, handleChangeSuppliers, loading, toggleFilter } = props;

    return (
        <div className="searchWrapper">
            <Container className="container" maxWidth="lg">
                <Grid container className="search">
                    <Grid item xs={3} className="title">
                        <Typography variant="h1" className="claim">
                            {
                                props.subtitle
                                ? <IntlMessage id={props.subtitle}/>
                                : <IntlMessage id="header.lodging.title"/>
                            }
                        </Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <SearchForm 
                            changeDestination={props.changeDestination} 
                            loading={loading} 
                            isLodging={true} 
                            searchQuery={props.searchQuery} 
                            searchHandler={searchHandler.bind(this)} 
                            toggleSearch={toggleSearch.bind(this)} 
                            className="searchBox" 
                            dateMode={props.config.config.searchbarType} 
                            config={props.config.config} 
                        />
                    </Grid>
                </Grid>
                {
                    props.subplan && props.subplan.length > 0 && props.subplan.map((item, idx) => {
                        return (
                            <Grid key={"subtitle_" + idx} container className="search subtitle">
                                <Grid item xs={12} className="title">
                                    <Typography variant="h1" className="claim">
                                        <IntlMessage id={item.label}/>
                                    </Typography>
                                </Grid>
                            </Grid>
                        )
                    })
                }
            </Container>
            
            <div className="mobilesearch drawers">
                <Drawer disablePortal={true} variant="temporary" anchor="bottom" open={props.search}>
                    <SearchForm 
                        resultCount={props.resultCount}
                        changeDestination={props.changeDestination} 
                        loading={loading} 
                        isLodging={true} 
                        searchQuery={props.searchQuery} 
                        searchHandler={searchHandler.bind(this)} 
                        toggleSearch={toggleSearch.bind(this)} 
                        className="searchBox" 
                        isMobile={true} 
                        dateMode={props.config.config.searchbarType} 
                        config={props.config.config} 
                        section={props.section}
                    />
                </Drawer>
                <Drawer disablePortal={true} variant="temporary" anchor="bottom" open={props.filter}>
                    <div className="sectionTitle">
                        <h2>Sort by</h2>
                    </div>
                    <Sortings 
                        sortOptions={props.config.config.sortOptions} 
                        enableSortings={props.enableSortings}
                        setSort={props.handleSetSort}
                    />
                    <div className="sectionTitle">
                        <h2>Filter by</h2>
                        <span onClick={() => resetFilters()}>Reset</span>
                    </div>
                    <FiltersBar config={props.config} make={props.make} suppliers={props.suppliers} isMobile={true} onChange={handleChangeSuppliers} sortOrder={props.sortOrder} />
                    <div className="bottomSearch">
                        <div className="ButtonWrapper">
                            <Button onClick={() => toggleFilter(false)} className="searchButton">Apply</Button>
                        </div>
                        <div className="closeBtn">
                            <Icon icon={"iw-close"} onClick={()=>toggleFilter(false)} size={24} className="closemenu" />
                        </div>
                    </div>
                </Drawer>
            </div>
        </div>
    )
}
